import { useMemo } from 'react';

import { printerDetailsQueryOptions, type PrinterDetails } from '@goshippo/print';

import { useQuery } from '@tanstack/react-query';

import { STABLE_QZ_QUERY_SETTINGS } from '../constants/qzQuery.const';
import { useShippoPrintState } from './useShippoPrintState';

const EMPTY_PRINTERS: PrinterDetails[] = [];

export const useLocalPrinters = () => {
  const connected = useShippoPrintState((state) => state.connected);

  const printersQuery = useQuery({
    ...printerDetailsQueryOptions,
    ...STABLE_QZ_QUERY_SETTINGS,
    enabled: connected,
  });

  const printers = connected ? printersQuery.data ?? EMPTY_PRINTERS : EMPTY_PRINTERS;
  const isFetched = !connected || printersQuery.isFetched;
  const isFetching = connected && !printersQuery.isFetched;

  return useMemo(
    () => ({
      connected,
      isFetched,
      isFetching,
      printers,
    }),
    [connected, isFetched, isFetching, printers],
  );
};
